import React from 'react';
import { useStyles } from './styles';
import { Box, Button } from '@material-ui/core';
import gogreenLogo from '../../assets/gogreenLogo.svg'
// import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { GoGreenAlert } from '..'
import { CommunicationConsentAlert } from '../../components';


export const DashboardCard = (props) => {

  const { bannerBody, bannerTitle,
    buttonColor, buttonText, titleBgColor } = props.banner;

  const { email, phone, accountNumber, isCommConcent,
    isMobileVerified, isGoGreen, isCommConcentMobile, IsSmsConsent, isEmailVerified
  } = props;

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => setOpen(true);
 
  const handleClose = (status) =>  {
    if (status) {
      props.handePopupClose()
    }
  
    setOpen(false)
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.header} style={{ backgroundColor: titleBgColor }}>
        <h1 className={classes.title}>{bannerTitle}</h1>
      </Box>
      <Box className={classes.body}>
        <img className={classes.logo} src={gogreenLogo} alt='logo' />
        <Box className={classes.bodyTextContainer}>
          <p className={classes.bodyText} dangerouslySetInnerHTML={{ __html: bannerBody }}></p>
        </Box>
      </Box>
      <Box className={classes.footer}>
        <Button className={classes.btn} style={{ backgroundColor: buttonColor }} onClick={handleClickOpen}>{buttonText}</Button>
      </Box>
      {/* <GoGreenAlert
        handleClose={handleClose}
        open={open}
        accountNumber={props.accountNumber}
        email={email}
        phone={phone}
      /> */}

      <CommunicationConsentAlert
        open={open}
        handleClose={handleClose}
        email={email}
        phone={phone}
        accountNumber={accountNumber}
        isCommConcent={isCommConcent}
        isCommConcentMobile={isCommConcentMobile}
        isGoGreen={isGoGreen}
        IsSmsConsent={IsSmsConsent}
        isVerified={isMobileVerified && isEmailVerified}
        isMobileVerified={isMobileVerified}
        isEmailVerified={isEmailVerified}
      />

    </Box>
  )
}
